import {createSlice} from "@reduxjs/toolkit";

const initialUsersState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};
const getIndex = (array, paymentRequestID) => {
  const mappedArray = array.map(item => item._id);
  return mappedArray.indexOf(paymentRequestID);
}

export const paymentsSlice = createSlice({
  name: "automatedPayments",
  initialState: initialUsersState,
  reducers: {
    paymentsFetched: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    paymentsAppended: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    statusUpdated: (state, action) => {
      const {paymentRequestID, updatedStatusID, updatedStatusText, lastStatusUpdateDate} = action.payload;
      const index = getIndex(state.entities, paymentRequestID);
      if (Boolean(state.entities)) {
        state.entities[index].statusID = updatedStatusID
        state.entities[index].statusText = updatedStatusText
        state.entities[index].lastStatusUpdateDate = lastStatusUpdateDate
      }
    },
    statusResent: (state, action) => {
      const {paymentRequestID, updatedStatusID, updatedStatusText, lastStatusUpdateDate} = action.payload;
      const index = getIndex(state.entities, paymentRequestID);
      if (Boolean(state.entities)) {
        state.entities[index].statusID = updatedStatusID
        state.entities[index].statusText = updatedStatusText
        state.entities[index].lastStatusUpdateDate = lastStatusUpdateDate
      }
    },
    amountUpdated: (state, action) => {
      const {paymentRequestID, debtAmount, insuranceAmount, totalAmount} = action.payload;
      const index = getIndex(state.entities, paymentRequestID);
      if (Boolean(state.entities)) {
        state.entities[index].debtAmount = debtAmount;
        state.entities[index].insuranceAmount = insuranceAmount;
        state.entities[index].totalAmount = totalAmount;
      }
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoicesError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
